import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash';

import { Dialog, DialogRef, DialogParams, DialogStringFunction } from '../../../dialog/dialog.base';
import { FormService } from '../../../form/form.service';
import { FormData } from '../../../form/classes/data';
import { FormSchemaData } from '../../../form/form.interface';

/**
 * @ignore
 */
@Component({
  selector: 'uex-dialog-prompt',
  templateUrl: './prompt.component.html'
})
export class DialogPromptComponent implements OnInit {
  constructor(
    private _dialogRef: DialogRef,
    private _dialogParams: DialogParams,
    private _formService: FormService
  ) {
    this.dialog = this._dialogRef.dialog;
    if(!this.dialog.settings.keyboard) {
      this.dialog.setKeyboard({
        onEscape: 'close',
        onReturn: () => this.resolve()
      });
    }
  }

  public dialog: Dialog;

  public form: FormData;

  public get headerClass(): string {
    return this._dialogParams.get('headerClass');
  }

  public get title(): string {
    return this._dialogParams.get('title');
  }

  public get titleClass(): string {
    return this._dialogParams.get('titleClass');
  }

  public get subtitle(): string {
    return this._dialogParams.get('subtitle');
  }

  public get subtitleClass(): string {
    return this._dialogParams.get('subtitleClass');
  }

  public get contentBefore(): string {
    return this._dialogParams.get('contentBefore');
  }

  public get contentAfter(): string {
    return this._dialogParams.get('contentAfter');
  }

  public get schema(): Array<FormSchemaData> {
    return this._dialogParams.get('schema');
  }

  public get footerClass(): string {
    return this._dialogParams.get('footerClass');
  }

  public get revertButtonOrder(): boolean {
    let revert_button_order: boolean = this._dialogParams.get('revertButtonOrder');
    return revert_button_order ? revert_button_order : false;
  }

  public get resolveButtonText(): string {
    let button_text: DialogStringFunction | string = this._dialogParams.get('resolveButtonText');
    if(_.isFunction(button_text)) {
      button_text = (<DialogStringFunction>button_text)();
    }
    return button_text ? (<string>button_text) : 'Ok';
  }

  public get resolveButtonMode(): string {
    let button_mode: string = this._dialogParams.get('resolveButtonMode');
    return button_mode ? button_mode : 'clear';
  }

  public get resolveButtonColor(): string {
    let button_color: string = this._dialogParams.get('resolveButtonColor');
    return button_color ? button_color : 'primary';
  }

  public get rejectButtonText(): string {
    let button_text: DialogStringFunction | string = this._dialogParams.get('rejectButtonText');
    if(_.isFunction(button_text)) {
      button_text = (<DialogStringFunction>button_text)();
    }
    return button_text ? (<string>button_text) : 'Cancelar';
  }

  public get rejectButtonMode(): string {
    let button_mode: string = this._dialogParams.get('rejectButtonMode');
    return button_mode ? button_mode : 'clear';
  }

  public get rejectButtonColor(): string {
    let button_color: string = this._dialogParams.get('rejectButtonColor');
    return button_color ? button_color : 'red';
  }

  public resolve() {
    if(this.form.validate(true)) {
      this.dialog.returnValue(this.form.value);
      this.dialog.close();
    }
  }

  public reject() {
    this.dialog.close();
  }

  public ngOnInit() {
    if(!this.schema || (this.schema && this.schema.length == 0)) {
      this.dialog.close();
      return;
    }

    let found_autofocus = false
    const schema = this.schema.map((_schema, index: number) => {
      _schema.grid = _.merge({}, _schema.grid, { cols: 12, offsets: 0 });
      if(!_schema.key) _schema.key = `${index}`;
      if(!found_autofocus && _schema.autofocus) found_autofocus = true;
      return _schema;
    });

    if(!found_autofocus) schema[0].autofocus = true;

    this.form = this._formService.create(schema);
  }
}
